import { Box, Container, Heading, Text, Stack } from "@chakra-ui/react";

export default function TermsOfUse() {
  return (
    <Box py={{ base: 10, md: 16 }}>
      <Container maxW="4xl">
        <Heading size="2xl" mb={4}>
          Terms of Use
        </Heading>
        <Stack spacing={4} fontSize="md">
          <Text>
            By using this site, you agree to these terms. Content is “as is” for
            educational purposes only.
          </Text>
          <Text>
            We don’t guarantee outcomes and aren’t liable for reliance on our
            content.
          </Text>
          <Text>We may update these terms at any time.</Text>
          <Text fontSize="sm" opacity={0.8}>
            Last updated: {new Date().toLocaleDateString()}
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
